import AdvisoryReviewReference from './ARR/List.vue'
import ARRCreate from './ARR/Create.vue'
import ARREdit from './ARR/Edit.vue'

import RQTeamList from './RQTeam/List.vue'

import QuestionsList from './Questions/List.vue'
import ClustersList from './Clusters/List.vue'
import EmailsList from './Emails/List.vue'

import QuestionnairesList from './Questionnaires/List.vue'
import QuestionnairesCreate from './Questionnaires/Create.vue'
import QuestionnairesEdit from './Questionnaires/Edit.vue'

import RatingsList from './Ratings/List.vue'

import LogsList from './Logs/List.vue'

export default [
  {
    path: 'review-reference',
    name: 'Review Reference',
    component: AdvisoryReviewReference,
    meta: {
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'review-reference/create',
    name: 'Create Review Reference',
    component: ARRCreate,
    meta: {
      title: 'Create Review Reference',
      profiles: ['admin']
    }
  },
  {
    path: 'review-reference/:id',
    name: 'Edit Review Reference',
    component: ARREdit,
    meta: {
      title: 'Edit Review Reference',
      profiles: ['admin'],
    }
  },
  {
    path: 'rq-team',
    name: 'Users Admin',
    component: RQTeamList,
    meta: {
      title: 'Users Admin',
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'questions',
    name: 'Questions',
    component: QuestionsList,
    meta: {
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'clusters',
    name: 'Clusters',
    component: ClustersList,
    meta: {
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'emails',
    name: 'Emails',
    component: EmailsList,
    meta: {
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'questionnaires/list/:id',
    name: 'Questionnaires',
    component: QuestionnairesList,
    meta: {
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'questionnaires/create',
    name: 'Create Questionnaire',
    component: QuestionnairesCreate,
    meta: {
      profiles: ['admin']
    }
  },
  {
    path: 'questionnaires/:id',
    name: 'Edit Questionnaire',
    component: QuestionnairesEdit,
    meta: {
      profiles: ['admin']
    }
  },
  {
    path: 'action-plans',
    name: 'Action Plans',
    component: RatingsList,
    meta: {
      profiles: ['admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'logs/:review_id',
    name: 'Logs',
    component: LogsList,
    meta: {
      profiles: ['admin', 'user', 'adminTi', 'audit']
    },
  }
]
